<template>
    <div class="data-grid-aside" v-loading="loading">
        <div class="data-grid-aside-action-sheet top">
            <div class="action-sheet-item" v-for="action in actionSheet" :key="action.command" @click="onActionClick(action)">
                <template v-if="action.placement === 'top'">
                    <common-icon :type="currentIsActive(action) ? action.activeIcon : action.icon" :size="14"></common-icon>
                    <span>{{currentIsActive(action) ? action.activeName : action.name}}</span>
                </template>
            </div>
        </div>
        <h-tree
            ref="tree"
            :data="data"
            :height="treeHeight"
            :props="props"
            :node-key="nodeKey"
            :action-sheet="actionSheet"
            @command="onTreeCommand"
            @current-change="onCurrentNodeChange"
        ></h-tree>
    </div>
</template>

<script>
export default {
  props: {
    data: {},
    props: {
      type: Object,
      default () {
        return {
          label: 'label',
          children: 'children',
          disabled: 'disabled',
          isLeaf: 'isLeaf'
        }
      }
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    actionSheet: {
      type: Array,
      default () {
        return []
      }
    },
    loading: false
  },
  data () {
    return {
      current: null,
      opts: {}
    }
  },
  computed: {
    treeHeight () {
      if (this.actionSheet && this.actionSheet.length) {
        // 21 高 + 10 外边距
        return `calc(100% - 31px)`
      } else {
        return `100%`
      }
    }
  },
  methods: {
    onCurrentNodeChange (data, node, leaf) {
      if (data[this.nodeKey] === this.current.data[this.nodeKey]) return
      this.current = {
        data,
        node
      }
      this.$emit('current-change', this.current)
    },
    currentIsActive (item) {
      return this.current && this.current.data && this.current.data[item.activeProp]
    },
    onActionClick (action) {
      this.emitCommand(action.command)
    },
    onTreeCommand (action, target) {
      this.emitCommand(action, target)
    },
    emitCommand (action, target) {
      if (target) this.$emit('command', action, target)
      else this.$emit('command', action, this.current)
    },
    // 树组件相关方法
    setCurrentKey (key) {
      this.$refs.tree.setCurrentKey(key)
      this.$nextTick(() => {
        let node = this.$refs.tree.getCurrentNode()
        if (node) {
          this.current = {
            data: node.data,
            node
          }
          this.$emit('current-change', this.current)
        }
      })
    }
  }
}
</script>

<style lang="less">
@import '../../color.less';
.data-grid-aside {
    width: 320px;
    flex: 0 0 320px;
    background: #fff;
    height: 100%;
    padding: 10px;
    overflow: hidden;
    border-radius: 4px;
    &:hover {
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    }
    &-action-sheet.top {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .action-sheet-item {
            flex: 1;
            font-size: 14px;
            text-align: center;
            cursor: pointer;
            &:hover {
                color: @primary;
            }
        }
        &.single {
            .action-sheet-item {
                text-align: left;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/aside.vue